import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  email: string;
  roles: string[];
  inviter: string;
  partner_id?: string;
}

export const useInviteUser = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (formData: MutationProps) => {
      return api.post("user/invite", formData);
    },

    onError: (res: any) => {
      console.error("[From Invite User]", res);

      handleErrors(res, "mutation");
    },
  });
};
